import clsx from 'clsx'
import {ReactElement, useState} from 'react'
import {OverlayTrigger, Popover} from 'react-bootstrap'
import {Placement} from 'react-bootstrap/esm/types'

type TooltipModalProps = {
  message: string | ReactElement
  className?: string
  messageTooltip?: string
  classNameTooltip?: string
  placement?: Placement
}
export const TooltipModal = ({
  message,
  className = '',
  messageTooltip = '',
  classNameTooltip = '',
  placement = 'bottom',
}: TooltipModalProps) => {
  const [showPopover, setShowPopover] = useState<Record<string, boolean>>({})

  return (
    <OverlayTrigger
      placement={placement}
      show={showPopover.id}
      overlay={
        messageTooltip ? (
          <Popover
            className='mw-350px p-5'
            onMouseEnter={() => setShowPopover((prev) => ({...prev, tooltip: true}))}
            onMouseLeave={() => setShowPopover((prev) => ({...prev, tooltip: false}))}
          >
            <div className={clsx('fw-bold text-truncate-2', classNameTooltip)}>
              {messageTooltip}
            </div>
          </Popover>
        ) : (
          <> </>
        )
      }
    >
      <div
        className={clsx('cursor-pointer text-truncate', className)}
        onMouseEnter={() => setShowPopover((prev) => ({...prev, tooltip: true}))}
        onMouseLeave={() => setShowPopover((prev) => ({...prev, tooltip: false}))}
      >
        {message}
      </div>
    </OverlayTrigger>
  )
}
